import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/alert/style";
import _Alert from "antd/lib/alert";
import "antd/lib/spin/style";
import _Spin from "antd/lib/spin";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/avatar/style";
import _Avatar from "antd/lib/avatar";
import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/breadcrumb/style";
import _Breadcrumb from "antd/lib/breadcrumb";
import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/form/style";
import _Form from "antd/lib/form";
import "antd/lib/layout/style";
import _Layout from "antd/lib/layout"; /*@通用页面-页面框架*/ /**********基础组件***********/
import React, { Suspense } from 'react';
import { Route, Switch } from 'dva/router';
import { Link, withRouter } from 'react-router-dom';
import 'moment/locale/zh-cn'; //日期国际化
import { menuDict } from './Menu/menuData2';
import AvatarCustomer from 'react-avatar';
import { injectIntl } from 'react-intl';
import mMessages from './locales/menuMessages'; /**********自有组件***********/
import MenuBar from './Menu/MenuBar'; /**********自有方法,assets***********/
import logoDark from '../../assets/img/logo.png';
import logoLight from '../../assets/img/logo-index.png';
import './index.scss';
import CI0301R from "../../routes/CI/CI0301R";
import CI0302R from "../../routes/CI/CI0302R";
import CI0401R from "../../routes/CI/CI0401R";
import CI0303R from "../../routes/CI/CI0303R";
import CI0304R from "../../routes/CI/CI0304R";
import CI0001R from "../../routes/CI/CI0001R";
import localeList from "../../locales/_localeList";
import { _crypto, localeMap } from '../../utils/commonUtilFunc';
import { domain, IconFont } from '../../utils/commonConsts';
import DysModal from './subComponents/DysModal';
import moment from "moment"; /**********变量***********/
var Sider = _Layout.Sider,
  Content = _Layout.Content;
var FormItem = _Form.Item;
var LayoutC = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutC, _React$Component);
  function LayoutC(props) {
    var _this;
    _classCallCheck(this, LayoutC);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LayoutC).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_logo", function () {
      _this.props.dispatch({
        type: "layoutInfo/get_logo",
        payload: {
          company_id: sessionStorage.getItem("companyId"),
          logo_type: 'logo'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "quit", function () {
      sessionStorage.clear();
      _this.props.dispatch({
        type: "layoutInfo/logout",
        payload: {}
      }).then(function () {
        _this.props.dispatch({
          type: "indexPage/hideCaptcha",
          payload: {}
        });
        _this.props.dispatch({
          type: "bi0001Info/setBossHeaderChooseValue",
          payload: {
            company_id: ''
          }
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeModalVisible", function (name) {
      _this.setState(_defineProperty({}, name, true));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleModalClose", function (name) {
      _this.setState(_defineProperty({}, name, false));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseFirstLoginModal", function () {
      _this.setState({
        firstLoginModalShow: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseExpireModal", function () {
      _this.setState({
        expireVisible: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChangePassword", function () {
      _this.setState({
        changePasswordShow: true,
        firstLoginModalShow: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update_password", function () {
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.dispatch({
            type: "layoutInfo/changepwd",
            payload: {
              newpassword: _crypto(values.newpassword.trim()),
              oldpassword: _crypto(values.oldpassword.trim())
            }
          });
        }
      });
    }); /**
        * 根据后台menu数据获取path列表
        * */
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPath", function (menuInfo) {
      var pathList = [];
      for (var key in menuInfo) {
        if (menuInfo[key].path) {
          pathList.push(menuInfo[key].path);
        }
        if (menuInfo[key].sub) {
          var subPathList = _this.getPath(menuInfo[key].sub);
          pathList = pathList.concat(subPathList);
        }
      }
      return pathList;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectLanguage", function (value, label) {
      _this.setState({
        selectedLang: label
      }, function () {
        window.location.href = domain + '/index.' + value + '.html#' + _this.props.location.pathname + _this.props.location.search;
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setCollapse", function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      }, function () {
        localStorage.setItem("collapse", _this.state.collapsed);
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTheme", function () {
      _this.setState({
        theme: _this.state.theme === "light" || _this.state.theme === null ? "dark" : "light"
      }, function () {
        localStorage.setItem("theme", _this.state.theme);
        _this.props.dispatch({
          type: "layoutInfo/changeTheme"
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "compareToFirstPassword", function (rule, value, callback) {
      var form = _this.props.form;
      if (value && value !== form.getFieldValue('newpassword')) {
        callback("The two passwords do not match");
      } else {
        callback();
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validateToNextPassword", function (rule, value, callback) {
      var form = _this.props.form;
      if (value && _this.state.confirmDirty) {
        form.validateFields(['confirmPassword'], {
          force: true
        });
      }
      callback();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validatePassword", function (rule, value, callback) {
      if (value) {
        if (value.trim().match(/[ ]/)) {
          callback("Passwords cannot contain spaces");
        } else if (!value.match(/[0-9]*$/)) {
          callback("Password must contain numbers");
        } else if (!value.match(/[A-Z]/)) {
          callback("Password must contain uppercase letters");
        } else if (!value.match(/[a-z]/)) {
          callback("Password must contain lowercase letters");
        } else if (!value.match(/[!\"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/)) {
          callback("Passwords must contain special characters");
        } else if (value.length < 8) {
          callback("The password length cannot be less than 8");
        } else {
          callback();
        }
      } else {
        callback();
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleConfirmBlur", function (e) {
      var value = e.target.value;
      _this.setState({
        confirmDirty: _this.state.confirmDirty || !!value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e) {
      sessionStorage.setItem("current", e.key);
      _this.setState({
        current: e && e.key,
        menuInfo: JSON.parse(sessionStorage.getItem("menuInfo"))[e.key]
      }, function () {
        var path = "";
        if (JSON.parse(sessionStorage.getItem("menuInfo"))[e.key][0].sub) {
          path = JSON.parse(sessionStorage.getItem("menuInfo"))[e.key][0].sub[0].path;
        } else {
          path = JSON.parse(sessionStorage.getItem("menuInfo"))[e.key][0].path;
        } //菜单第一项为默认首页
        _this.props.history.push("/main/" + path);
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkPathName", function () {
      var menuInfo = JSON.parse(sessionStorage.getItem('menuInfo'));
      var pathname = _this.props.location.pathname;
      var current = '';
      var selectedKeys = [];
      var openkeys = [];
      for (var i in menuInfo) {
        for (var j in menuInfo[i]) {
          if (pathname.indexOf(menuInfo[i][j].path) > -1) {
            current = i;
            selectedKeys = [String(menuInfo[i][j].id)];
            return {
              current: current,
              selectedKeys: selectedKeys
            };
          }
          if (menuInfo[i][j].sub) {
            for (var k in menuInfo[i][j].sub) {
              if (pathname.indexOf(menuInfo[i][j].sub[k].path) > -1) {
                current = i;
                openkeys = [String(menuInfo[i][j].id)];
                selectedKeys = [String(menuInfo[i][j].sub[k].id)];
                return {
                  current: current,
                  selectedKeys: selectedKeys,
                  openkeys: openkeys
                };
              }
            }
          }
        }
      }
      return {
        current: current,
        selectedKeys: selectedKeys,
        openkeys: openkeys
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "send_code", function (payload) {
      _this.props.dispatch({
        type: "indexPage/send_code",
        payload: payload
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update_2fa", function (values) {
      _this.props.dispatch({
        type: "indexPage/update_2fa",
        payload: _objectSpread({}, values, {
          verify_channel: values.verify_channel ? values.verify_channel : '',
          id: parseInt(sessionStorage.getItem('person_id'))
        })
      }).then(function () {
        _this.handleModalClose('dysModalVisible');
      });
    });
    _this.state = {
      menuInfo: _this.props.indexPage.menuInfo['home'],
      userNm: '',
      changePasswordShow: sessionStorage.getItem("need_change_password") === 'true',
      firstLoginModalShow: false,
      collapsed: !(localStorage.getItem("collapse") === null || localStorage.getItem("collapse") === "false"),
      selectedLang: localeMap(window.appLocale.locale),
      theme: localStorage.getItem("theme"),
      confirmDirty: false,
      expireVisible: false,
      current: "home",
      need_change_password: sessionStorage.getItem("need_change_password") === 'true' ? true : false,
      dysModalVisible: false
    };
    return _this;
  }
  _createClass(LayoutC, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var ifLogin = sessionStorage.getItem("ifLogin");
      var userNm = sessionStorage.getItem("userNm"); // if(this.props.indexPage.menuInfo && JSON.stringify(this.props.indexPage.menuInfo) !== '{}'){
      //     this.setState({
      //         menuInfo: sessionStorage.getItem("current")? this.props.indexPage.menuInfo[sessionStorage.getItem("current")]:this.props.indexPage.menuInfo['home']
      //     })
      // } else {
      //     this.setState({
      //         menuInfo:sessionStorage.getItem("current")?JSON.parse(sessionStorage.getItem("menuInfo"))[sessionStorage.getItem("current")]:JSON.parse(sessionStorage.getItem("menuInfo"))['home']
      //     })
      // }
      if (ifLogin === "false" || !ifLogin) {
        this.props.history.push("/");
      } else {
        this.setState({
          userNm: userNm
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.layoutInfo.ifChangedPwd) {
        var model = _Modal.success({
          title: "Successfully modified password"
        });
        setTimeout(function () {
          model.destroy();
          _this2.props.history.push("/");
          _this2.props.layoutInfo.ifChangedPwd = false;
        }, 2000);
      }
      var firstLogin = sessionStorage.getItem("first_login");
      if (firstLogin === 'true') {
        this.setState({
          firstLoginModalShow: true
        }, function () {
          sessionStorage.setItem("first_login", 'false');
        });
      }
      var near_expire = sessionStorage.getItem("near_expire");
      if (near_expire === 'true') {
        this.setState({
          expireVisible: true
        }, function () {
          sessionStorage.setItem("near_expire", "false");
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // const startTime = '1689767651';
      // // const endTime = '1689766479';
      // if( startTime<moment().unix()){
      //     message.info('尊敬的用户，本公司计划于2023年7月19日23:00-2023年7月20日02:00间进行管理后台升级维护，维护期间可能出现控制台页面显示异常，请在维护窗口结束后再行登录。如维护期间有任何需求请联系技术支持工程师，给您带来不便之处，敬请谅解。',60);
      // }
      if (sessionStorage.getItem("role") === "company" || sessionStorage.getItem("role") === "companystaff") {
        this.get_logo();
      } //登陆后首屏渲染
      var frontPage = ["/main/ci0801", "/main/bi0101", "/main/mi0001", "/main/pc0101"];
      if (frontPage.indexOf(this.props.location.pathname) > -1) {
        this.props.history.push(this.props.location.pathname);
      }
      this.props.dispatch({
        type: "layoutInfo/changeTheme"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var dysProps = {
        visible: this.state.dysModalVisible,
        cancel: function cancel() {
          return _this3.handleModalClose('dysModalVisible');
        },
        send_code: this.send_code,
        onOk: this.update_2fa,
        initialValue: {
          is_active: sessionStorage.getItem('is_active') === 'true' ? true : false,
          verify_channel: sessionStorage.getItem('verify_channel') ? sessionStorage.getItem('verify_channel') : ''
        }
      };
      var current = 'home';
      var menuInfo = [];
      var selectedKeys = [];
      var openkeys = [];
      if (sessionStorage.getItem('menuInfo')) {
        current = this.checkPathName().current || '';
        selectedKeys = this.checkPathName().selectedKeys || [];
        openkeys = this.checkPathName().openkeys || [];
        menuInfo = JSON.parse(sessionStorage.getItem('menuInfo'))[current];
      }
      var __ = this.props.intl.formatMessage;
      var getFieldDecorator = this.props.form.getFieldDecorator;
      var modalFormLayout = {
        labelCol: {
          xs: {
            span: 5
          }
        },
        wrapperCol: {
          xs: {
            span: 16
          }
        }
      }; /**
         * 布局面包屑组件名称
         * */
      var location = this.props.location;
      var pathSnippets = location.pathname.split('/').filter(function (i) {
        return i;
      });
      var breadcrumbItems = /*#__PURE__*/React.createElement(_Breadcrumb.Item, {
        key: pathSnippets[1]
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/main/" + pathSnippets[1],
        key: menuDict[pathSnippets[1]]
      }, menuDict[pathSnippets[1]] ? menuDict[pathSnippets[1]].name === "home page" ? "" : __(mMessages[menuDict[pathSnippets[1]].name]) : "")); // const breadcrumbItems = [(
      //     <Breadcrumb.Item key="home">
      //         {(sessionStorage.getItem("role") === "company" || sessionStorage.getItem("role") === "companystaff") ?
      //             <Link to={"/main/ci0801"}>
      //                 {"@首页"}
      //             </Link> : ""}
      //     </Breadcrumb.Item>
      // )].concat(extraBreadcrumbItems);
      /**
               * 通过对比后台传的menu数据,控制路由渲染
               * */ // let menuList = this.getPath(menuInfo);
      var Routes = [];
      for (var key in menuDict) {
        // if (menuList.indexOf(key) > -1) {
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/" + key,
          component: menuDict[key].component,
          key: key
        }));
        if (menuDict[key].sub) {
          for (var i = 0; i < menuDict[key].sub.length; i++) {
            Routes.push(/*#__PURE__*/React.createElement(Route, {
              exact: true,
              path: "/main" + menuDict[key].sub[i].path,
              component: menuDict[key].sub[i].component,
              key: menuDict[key].sub[i].path
            }));
          }
        } // }
      }
      if (sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin") {
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0301",
          component: CI0301R,
          key: "ci0301"
        }));
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0302",
          component: CI0302R,
          key: "ci0302"
        }));
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0303",
          component: CI0303R,
          key: "ci0303"
        }));
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0303/ci0304",
          component: CI0304R,
          key: "ci0304"
        }));
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0401",
          component: CI0401R,
          key: "ci0401"
        }));
      }
      if (sessionStorage.getItem("role") === 'company' || sessionStorage.getItem("role") === 'companystaff') {
        Routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          path: "/main/ci0001",
          component: CI0001R,
          key: "ci0001"
        }));
      }
      var role = this.props.indexPage.role || sessionStorage.getItem("roleName");
      var roleColor = this.props.indexPage.roleColor || sessionStorage.getItem("roleColor");
      var userNm = this.state.userNm;
      var roleMap = {
        "企业管理员": "Enterprise administrator",
        "普通用户": "Ordinary users",
        "商务": "business affairs",
        "运维": "Operation and maintenance",
        "技术支持": "technical support",
        "商务主管": "Business Supervisor",
        "账号管理员": "IT Account Administrator ",
        "技术支持主管": "Technical Support Supervisor"
      };
      var userInfoMenu = /*#__PURE__*/React.createElement(_Menu, {
        style: {
          width: 306,
          marginTop: 1,
          padding: "0px",
          borderTop: this.state.theme === "dark" ? "3px solid #4C81E1" : ""
        },
        theme: this.state.theme
      }, /*#__PURE__*/React.createElement(_Menu.Item, {
        style: {
          height: 80,
          backgroundColor: this.state.theme === "dark" ? "rgba(0,21,42,0.65)" : "#F6F7FB"
        }
      }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
        span: 6
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center",
          height: 64,
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(AvatarCustomer, {
        size: 62,
        round: true,
        textSizeRatio: 6,
        color: roleColor,
        name: roleMap[role]
      }))), /*#__PURE__*/React.createElement(_Col, {
        span: 18,
        style: {
          paddingTop: 8
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "left",
          fontSize: 16,
          fontWeight: 'bold',
          marginTop: 5,
          marginLeft: 5,
          color: this.state.theme === "dark" ? "#fff" : "rgb(0,0,0)"
        }
      }, userNm), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 5,
          marginTop: 5,
          textAlign: "left",
          fontSize: 14,
          fontWeight: 'regular',
          color: this.state.theme === "dark" ? "#fff" : "rgb(153,153,153)"
        }
      }, roleMap[role])))), /*#__PURE__*/React.createElement(_Menu.Item, {
        style: {
          height: 45
        }
      }, /*#__PURE__*/React.createElement(_Row, {
        size: "small",
        onClick: function onClick() {
          return _this3.changeModalVisible('changePasswordShow');
        },
        style: {
          color: this.state.theme === "dark" ? "#fff" : "rgb(144,144,144)",
          fontFamily: "PingFangSC-Regular",
          fontWeight: "normal",
          marginLeft: 8,
          lineHeight: "35px"
        }
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-mima",
        theme: "outlined"
      }), "\xA0\xA0", "Change Password")), /*#__PURE__*/React.createElement(_Menu.Item, {
        style: {
          height: 45
        }
      }, /*#__PURE__*/React.createElement(_Row, {
        size: "small",
        onClick: function onClick() {
          return _this3.changeModalVisible('dysModalVisible');
        },
        style: {
          color: this.state.theme === "dark" ? "#fff" : "rgb(144,144,144)",
          fontFamily: "PingFangSC-Regular",
          fontWeight: "normal",
          marginLeft: 8,
          lineHeight: "35px"
        }
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-mima",
        theme: "outlined"
      }), "\xA0\xA0", "Multifactor authentication")), /*#__PURE__*/React.createElement(_Menu.Item, {
        style: {
          height: 45
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        style: {
          color: this.state.theme === "dark" ? "#fff" : "rgb(144,144,144)",
          fontWeight: "normal",
          lineHeight: "35px"
        }
      }, /*#__PURE__*/React.createElement(_Row, {
        size: "large",
        onClick: this.quit,
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-tuichu5",
        theme: "outlined",
        style: {
          marginLeft: 8
        }
      }), "\xA0\xA0", "Log out"))));
      var languageMenu = /*#__PURE__*/React.createElement(_Menu, {
        theme: this.state.theme,
        style: {
          borderTop: this.state.theme === "dark" ? "3px solid #4C81E1" : ""
        }
      }, localeList.map(function (lang) {
        return /*#__PURE__*/React.createElement(_Menu.Item, {
          key: lang.name,
          onClick: function onClick() {
            return _this3.handleSelectLanguage(lang.name, lang.label);
          }
        }, lang.label);
      }));
      var data = sessionStorage.getItem("expire_date") ? sessionStorage.getItem("expire_date") : '';
      var isLeftShow = true;
      if (current === 'home' || this.props.location.pathname.indexOf('ci0001') > -1) {
        if (sessionStorage.getItem('role') === 'supercxpadmin') {
          isLeftShow = true;
        } else {
          isLeftShow = false;
        }
      } else {
        isLeftShow = true;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "mainContainer"
      }, 1772269695 < moment().unix() && moment().unix() < 1772402400 ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute',
          width: "50%",
          left: "25%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          padding: '8px',
          borderRadius: '8px',
          zIndex: '999',
          background: '#fff',
          top: '20px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red'
        }
      }, "\u901A\u544A\uFF1A"), "\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u672C\u516C\u53F8\u540E\u53F0\u6570\u636E\u91C7\u96C6\u7CFB\u7EDF\u5C06\u4E8E2026\u5E742\u670828\u65E518:30-3\u67082\u65E506:00\u95F4\u8FC1\u79FB\u5386\u53F2\u6570\u636E\uFF0C\u6B64\u671F\u95F4\u53EF\u80FD\u51FA\u73B0\u5386\u53F2\u66F2\u7EBF\u65AD\u70B9\u6216\u65E0\u6570\u636E\u7684\u73B0\u8C61\uFF0C\u8BF7\u77E5\u6653\uFF0C\u8FC1\u79FB\u8FC7\u7A0B\u4E0D\u5F71\u54CD\u7F51\u7EDC\u5B9E\u9645\u8FD0\u884C\uFF0C\u5982\u9700\u67E5\u770B\u5386\u53F2\u6570\u636E\u70E6\u8BF7\u7B49\u5F85\u4E0B\u5468\u4E00\uFF083\u67082\u65E5\uFF09\u8FC1\u79FB\u5B8C\u6210\u3002") : '', /*#__PURE__*/React.createElement("header", {
        className: this.state.theme === "dark" ? "headerContainer-dark" : "headerContainer-light",
        id: "main-header"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-left"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          minWidth: '200px',
          display: 'inline-block',
          paddingLeft: 20
        }
      }, sessionStorage.getItem("role") === "company" || sessionStorage.getItem("role") === "companystaff" ? /*#__PURE__*/React.createElement("img", {
        src: this.props.layoutInfo.logo_url === "default" ? this.state.theme === "dark" ? logoDark : logoLight : domain + this.props.layoutInfo.logo_url + "&temp=" + Math.random().toString(),
        alt: "",
        className: "logo"
      }) : this.state.theme === "dark" ? /*#__PURE__*/React.createElement("img", {
        src: "../pic/logo-dark.png",
        alt: ""
      }) : /*#__PURE__*/React.createElement("img", {
        src: "../pic/logo-white.png",
        alt: ""
      })), sessionStorage.getItem("role") !== 'supercxpadmin' ? /*#__PURE__*/React.createElement("div", {
        className: "menuline"
      }, /*#__PURE__*/React.createElement(_Menu, {
        theme: this.state.theme,
        onClick: this.handleClick,
        selectedKeys: [current],
        mode: "horizontal"
      }, /*#__PURE__*/React.createElement(_Menu.Item, {
        key: "home",
        name: "\u9996\u9875",
        label: "\u9996\u98751"
      }, "home page"), /*#__PURE__*/React.createElement(_Menu.Item, {
        key: "monitoring"
      }, "monitor"), sessionStorage.getItem('companyonlyshow') == 'false' ? /*#__PURE__*/React.createElement(_Menu.Item, {
        key: "configuration"
      }, "to configure") : '', /*#__PURE__*/React.createElement(_Menu.Item, {
        key: "analyze"
      }, "analysis"), sessionStorage.getItem('companyonlyshow') == 'false' ? /*#__PURE__*/React.createElement(_Menu.Item, {
        key: "manage"
      }, "Administration") : '')) : ''), /*#__PURE__*/React.createElement("div", {
        className: "header-widget"
      }, /*#__PURE__*/React.createElement(_Dropdown, {
        overlay: userInfoMenu,
        placement: "bottomCenter"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement(_Avatar, {
        size: "default",
        style: {
          marginRight: 8,
          backgroundColor: roleColor
        },
        color: roleColor
      }, role), userNm))), sessionStorage.getItem("role") === 'company' || sessionStorage.getItem("role") === 'companystaff' ? /*#__PURE__*/React.createElement("div", {
        className: "header-widget headerhover"
      }, /*#__PURE__*/React.createElement(_Icon, {
        className: "icon",
        type: "appstore",
        theme: "filled"
      }), /*#__PURE__*/React.createElement("a", {
        className: "title",
        href: domain + "/index." + window.appLocale.locale + ".html#/main/ci0001"
      }, "Client Download")) : '', /*#__PURE__*/React.createElement("div", {
        className: "header-widget headerhover"
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-diqiu1",
        className: "icon"
      }), /*#__PURE__*/React.createElement(_Dropdown, {
        overlay: languageMenu,
        placement: "bottomCenter"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.state.selectedLang))), /*#__PURE__*/React.createElement("div", {
        className: "header-widget headerhover",
        onClick: this.selectTheme
      }, /*#__PURE__*/React.createElement(IconFont, {
        type: "icon-yifu",
        className: "icon"
      }), /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.state.theme === "dark" ? "Dark color" : "light colour")))), this.state.theme !== "dark" ? /*#__PURE__*/React.createElement("div", {
        className: "dash"
      }) : "", /*#__PURE__*/React.createElement(_Layout, {
        className: "contentContainer",
        id: "main-content"
      }, isLeftShow ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Sider, {
        theme: this.state.theme,
        className: "sider",
        collapsed: this.state.collapsed,
        trigger: null,
        collapsedWidth: 56
      }, /*#__PURE__*/React.createElement(MenuBar, {
        collapsed: this.state.collapsed,
        menuInfo: menuInfo,
        selectedKeys: selectedKeys,
        openkeys: openkeys,
        theme: this.state.theme
      })), /*#__PURE__*/React.createElement("div", {
        className: this.state.theme === 'dark' ? 'layoutIconBox layoutIconBoxdark' : 'layoutIconBox'
      }, /*#__PURE__*/React.createElement(_Icon, {
        onClick: this.setCollapse,
        className: "icon",
        type: this.state.collapsed ? "double-right" : "double-left"
      }))) : '', /*#__PURE__*/React.createElement(_Layout, {
        className: "siderRight",
        style: {
          backgroundColor: "#f0f2f5"
        }
      }, /*#__PURE__*/React.createElement(Content, {
        className: "route-view",
        style: {
          paddingRight: this.props.location.pathname === "/main/pc0101" ? 0 : 16
        }
      }, this.props.location.pathname === "/main/ci0801" || this.props.location.pathname === "/main/pc0101" || this.props.location.pathname === "/main/bi0101" || this.props.location.pathname === "/main/mi0001" ? "" : /*#__PURE__*/React.createElement("div", {
        className: "breadCrumbBar"
      }, /*#__PURE__*/React.createElement(_Breadcrumb, {
        separator: ">"
      }, breadcrumbItems)), /*#__PURE__*/React.createElement("div", {
        "class": "rightmaincon"
      }, /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }, /*#__PURE__*/React.createElement(_Spin, null))
      }, /*#__PURE__*/React.createElement(Switch, null, Routes)))))), /*#__PURE__*/React.createElement(_Modal, {
        maskClosable: false,
        keyboard: false,
        title: this.state.need_change_password ? /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '0 60px 0 34px'
          }
        }, /*#__PURE__*/React.createElement(_Alert, {
          message: "In response to the mandatory requirements of regulatory authorities regarding platform account security, please reset the password with standardized strength (the new password must contain uppercase letters, lowercase letters, numbers, and special charact",
          type: "warning",
          showIcon: true
        })) : "Change Password",
        closable: !this.state.need_change_password,
        visible: this.state.changePasswordShow,
        footer: this.state.need_change_password ? [/*#__PURE__*/React.createElement(_Button, {
          key: "submit",
          type: "primary",
          onClick: this.update_password
        }, "determine")] : [/*#__PURE__*/React.createElement(_Button, {
          key: "back",
          onClick: function onClick() {
            return _this3.handleModalClose('changePasswordShow');
          }
        }, "cancel"), /*#__PURE__*/React.createElement(_Button, {
          key: "submit",
          type: "primary",
          onClick: this.update_password
        }, "determine")],
        onCancel: function onCancel() {
          return _this3.handleModalClose('changePasswordShow');
        },
        onOk: this.update_password
      }, /*#__PURE__*/React.createElement(_Form, null, /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: "Original password"
      }, modalFormLayout), getFieldDecorator('oldpassword', {
        rules: [{
          required: true,
          message: "Please enter the original password"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        autocomplete: "false",
        type: "password",
        placeholder: "Please enter the original password"
      }))), /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: /*#__PURE__*/React.createElement("span", null, "New password", "\xA0", /*#__PURE__*/React.createElement(_Tooltip, {
          title: "Note: The new password must contain uppercase letters, lowercase letters, numbers, and special characters, and the length cannot be less than 8"
        }, /*#__PURE__*/React.createElement(_Icon, {
          type: "question-circle-o"
        })))
      }, modalFormLayout), getFieldDecorator('newpassword', {
        rules: [{
          required: true,
          message: "Please enter a new password"
        }, {
          validator: this.validateToNextPassword
        }, {
          validator: this.validatePassword
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        autocomplete: "false",
        type: "password",
        placeholder: "Please enter a new password"
      }))), /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: /*#__PURE__*/React.createElement("span", null, "Confirm Password", "\xA0", /*#__PURE__*/React.createElement(_Tooltip, {
          title: "Note: The new password must contain uppercase letters, lowercase letters, numbers, and special characters, and the length cannot be less than 8"
        }, /*#__PURE__*/React.createElement(_Icon, {
          type: "question-circle-o"
        })))
      }, modalFormLayout), getFieldDecorator('confirmPassword', {
        rules: [{
          required: true,
          message: "Please confirm the password"
        }, {
          validator: this.compareToFirstPassword
        }, {
          validator: this.validatePassword
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        autocomplete: "false",
        onBlur: this.handleConfirmBlur,
        type: "password",
        placeholder: "Please confirm the password"
      }))))), /*#__PURE__*/React.createElement(_Modal, {
        footer: null,
        maskClosable: false,
        visible: this.state.firstLoginModalShow,
        onCancel: this.handleCloseFirstLoginModal
      }, /*#__PURE__*/React.createElement("div", {
        className: "first-login-modal-title"
      }, "For the security of your account, please modify your login password in a timely manner"), /*#__PURE__*/React.createElement("div", {
        className: "first-login-modal-btn"
      }, /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        onClick: this.handleChangePassword
      }, "Go to modify password")), /*#__PURE__*/React.createElement("div", {
        className: "first-login-modal-return",
        onClick: this.handleCloseFirstLoginModal
      }, "Return to the management page")), /*#__PURE__*/React.createElement(_Modal, {
        visible: this.state.expireVisible,
        title: "Trial is about to expire reminder",
        onOk: this.handleCloseExpireModal,
        onCancel: this.handleCloseExpireModal
      }, /*#__PURE__*/React.createElement("div", {
        className: "expire-modal"
      }, "Your company's trial will take place on", /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontSize: '20px'
        }
      }, data), "Expiration, please contact our sales personnel to renew the contract!")), this.state.dysModalVisible ? /*#__PURE__*/React.createElement(DysModal, dysProps) : '');
    }
  }]);
  return LayoutC;
}(React.Component);
export default injectIntl(withRouter(LayoutC));